import { Outlet } from 'react-router-dom';
import { useState } from 'react';
import Sidebar from './Sidebar';
import AdForgeLogo from '../../../components/feature/AdForgeLogo';
import { CreditsProvider } from '../../../context/CreditsContext';
import CreditToastContainer from '../../../components/feature/CreditToastContainer';

export default function DashboardLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <CreditsProvider>
      <div
        className="flex h-screen bg-stone-50 overflow-hidden"
        style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
      >
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap"
        />

        {/* Mobile backdrop */}
        {mobileOpen && (
          <div
            className="fixed inset-0 bg-black/50 z-40 md:hidden"
            onClick={() => setMobileOpen(false)}
          />
        )}

        {/* Sidebar */}
        <div
          className={`fixed inset-y-0 left-0 z-50 transition-transform duration-300
            md:relative md:translate-x-0 md:block
            ${mobileOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}`}
        >
          <Sidebar
            collapsed={collapsed}
            onToggle={() => setCollapsed(!collapsed)}
            onMobileClose={() => setMobileOpen(false)}
          />
        </div>

        {/* Main content */}
        <div className="flex-1 overflow-y-auto flex flex-col min-w-0">
          {/* Mobile-only top bar */}
          <div className="md:hidden flex items-center gap-3 h-12 px-4 bg-white border-b border-stone-100 shrink-0 z-10">
            <button
              onClick={() => setMobileOpen(true)}
              className="w-8 h-8 flex items-center justify-center rounded-md text-stone-600 hover:bg-stone-100 transition-colors cursor-pointer"
              aria-label="Open menu"
            >
              <i className="ri-menu-line text-lg" />
            </button>
            <AdForgeLogo size="sm" light={false} />
          </div>

          <Outlet />
        </div>

        {/* Credit toast notifications */}
        <CreditToastContainer />
      </div>
    </CreditsProvider>
  );
}
